import "core-js/stable"
import "regenerator-runtime/runtime"
import '@fortawesome/fontawesome-free/js/all.js'
import 'jquery-inview'
import 'jquery.easing'
import { stringify } from 'querystring'
import Modal from './modal'
import authPasswordHtml from '../../html/auth_password.html'
import authCardHtml from '../../html/auth_card.html'
import gtag, { install } from 'ga-gtag'
import { resolve } from "path"
import SmoothScroll from 'smooth-scroll'
import CryptoJS from 'crypto-js'

let ga_id
if (document.querySelector('meta[name="ga_id"]')) {
    let options = document.domain == 'francerestaurantweek.com' ? {} : { debug_mode: true }
    ga_id = document.querySelector('meta[name="ga_id"]').getAttribute('content')
    install(ga_id, options)
}

export const imgPreload = imgPathList => {
    return Promise.all(imgPathList.map(_path => {
        return new Promise((resolve, reject) => {
            let img = new Image()
            img.onload = () => {
                resolve();
            }
            img.onerror = () => {
                reject();
            }
            img.src = _path;
        })
    }))
}

// スクロール時のフェードアクション
export const setInview = (delayVal = 400) => {
    $('.inview,.inview-fade,.inview-right').one('inview', (e, isInView) => {
        if (isInView) {
            $(e.currentTarget).stop().delay(delayVal).queue(function () {
                $(e.currentTarget).addClass('action').dequeue()
            })
        }
    })
}

export const setInnerScroll = () => {
    const scroll = new SmoothScroll('a[href*="#"]:not(.jslink)', {
        speed: 300,//スクロールする速さ
    });
}

export const getLocation = async (optionObj = {}) => {
    if (!navigator.geolocation) {
        return Promise.reject()
    }
    return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resp => {
            resolve(resp)
        },
            () => {
                reject()
            }, optionObj)
    })
}

export const submitFetch = async (data, path, type, params = {}) => {
    let send = Object.assign({}, params, {
        method: type,
        credentials: 'same-origin',
    })
    switch (type) {
        case 'GET':
            let bodyStringify = stringify(data)
            path = bodyStringify ? `${path}?${bodyStringify}` : path
            break
        default:
            let formData = new FormData()
            for (let key in data) {
                formData.append(key, data[key]);
            }
            Object.assign(send, { body: formData })
    }
    let resp = await fetch(path, send)
    return await resp.json()
}

export const selectArea = () => {
    $.ajax({
        url: '/entry/api/area',
        type: 'get',
        dataType: 'json',
    })
        .done(resp => {
            const setArea = () => {
                let city
                let areaValue
                if (city = $('select.area_city').val()) {
                    areaValue = city
                }
                if (!areaValue) {
                    areaValue = $('select.area_pref').val()
                }
                $('input[name="area"]').val(areaValue)
            }

            let areaList = resp.data
            $('select.area_pref').on('change', e => {
                let pref = $(e.currentTarget).val()
                let cityList = areaList.area.filter(_val => {
                    let ptn = new RegExp('^' + pref + '_')
                    return _val.key.match(ptn)
                })
                $('select.area_city').children().slice(1).remove()
                cityList.forEach(_val => {
                    let optionObj = $('<option />').val(_val.key).text(_val.value)
                    $('select.area_city').append(optionObj)
                })
                setArea()
            })
            $('select.area_city').on('change', e => {
                setArea()
            })
            let areaText = $('input[name="area"]').val()
            if (areaText) {
                let keys = areaText.split('_')
                $('select.area_pref').val(keys[0]).trigger('change')
                $('select.area_city').val(keys.length == 2 ? areaText : "").trigger('change')
            }
        })
}

export const authModal = async (modalType, params) => {
    const modal = new Modal()

    let modalHtml
    switch (modalType) {
        case 'premium':
            modalHtml = authPasswordHtml
            break
        case 'member':
            modalHtml = authCardHtml
            break
        default:
            return Promise.reject()
    }

    return new Promise((resolve, reject) => {
        modal
            .setHtml(modalHtml)
            .setEvent(obj => {
                obj.find('form').submit(async (e) => {
                    e.preventDefault()
                    let password = $(e.currentTarget).find('input[type="password"]').val()
                    $(e.currentTarget).find('.error_message').remove()
                    if (!password) {
                        let errorMessageObj = $('<p />').addClass('error_message').text('パスワードを入力してください。')
                        $(e.currentTarget).find('input[type="password"]').after(errorMessageObj)
                        return false
                    }
                    const resp = await submitFetch({ ...params, password }, $(e.currentTarget).attr('action'), 'POST')
                        .catch(resp => {
                            let errorMessageObj = $('<p />').addClass('error_message').text('パスワードが異なります。')
                            $(e.currentTarget).find('input[type="password"]').after(errorMessageObj)
                            return null
                        })
                    if (resp && resp.success) {
                        modal.close()
                        resolve(resp)
                    }
                    return false
                })
            })
            .show()
    })
}

export const createResvButtons = (encrypt, password, target, tagName = 'a') => {
    const decrypted = decrypt(encrypt, password);
    if (!decrypted) return false;
    target.empty()

    let attr = ''
    switch(tagName) {
        case 'a':
            attr = 'href';
            break;
        case 'button':
            attr = 'data-url';
            break;
    }
    const data = JSON.parse(decrypted)
    if (data.online) {
        const resvBtn = $(`<${tagName} />`).addClass('button online-resv').attr(attr, data.online).text('オンライン予約')
        if(tagName == 'a') {
            resvBtn.attr('target', '_blank')
        }
        target.append(resvBtn)
    }
    if (data.tel) {
        const telBtn = $(`<${tagName} />`).addClass('button tel-resv').attr(attr, `tel:${data.tel}`).html(`電話予約<span>${data.tel}</span>`)
        target.append(telBtn)
    }
    // 電話予約クリック時のanalytics記録
    target.find('.button.tel-resv').off().on('click', e => {
        if(e.tagName == 'button') {
            e.preventDefault()
        }
        const target = $(e.currentTarget).closest('.item')
        const type = target.attr('data-type')
        const restaurant = target.attr('data-restaurant')
        const id = target.attr('data-id')
        const label = id ? `${id}: ${restaurant}` : restaurant

        gtag('event', 'click', {
            'event_category': `reserve_tel_${type}`,
            'event_label': label,
            'non_interaction': true
        })
    })

    target.find('.button.online-resv').off().on('click', e => {
        if(e.tagName == 'button') {
            e.preventDefault()
        }
        const target = $(e.currentTarget).closest('article')
        const type = target.attr('data-type')
        const restaurant = target.attr('data-restaurant')

        gtag('event', 'click', {
            'event_category': `reserve_online_${type}`,
            'event_label': `${restaurant}`,
            'non_interaction': true
        })
    })
}

export const getAgentType = () => {
    var ua = [
        "iPod",
        "iPad",
        "iPhone",
        "Android"
    ]

    for (var i = 0; i < ua.length; i++) {
        if (navigator.userAgent.indexOf(ua[i]) > 0) {
            return ua[i]
        }
    }
    return "Other"
}

export const setGAEvent = (target = null) => {
    let baseUrl = window.location.protocol + "//" + window.location.hostname

    let ptn = new RegExp("^" + baseUrl)
    if (!ga_id) {
        return false
    }
    target = target ? target.find('a[href^="http"]') : $('a[href^="http"]')
    target.each((idx, _obj) => {
        if (ptn.test($(_obj).attr('href'))) {
            return true
        }
        $(_obj).on('click', e => {
            let link = $(e.currentTarget).attr('href')
            if (ga_id) {
                gtag('event', 'click', { 'event_category': 'link', 'event_label': link })
            }
        })
    })
}

export const getDevice = () => {
    const breakpointTablet = 1200
    const breakpointMobile = 640
    return window.innerWidth > breakpointTablet ? "pc" : (window.innerWidth > breakpointMobile ? "tab" : "sp")
}

export const encrypt = (message, passphrase) => {
    const key = CryptoJS.SHA256(passphrase); // 任意の長さのキーをハッシュ化して32バイトにする
    const iv = CryptoJS.lib.WordArray.random(16); // 16バイトのIVを生成
    const encrypted = CryptoJS.AES.encrypt(message, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
    });
    const encryptedMessage = iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
    return encryptedMessage;
}

export const decrypt = (encryptedText, passphrase) => {
    const encryptedBytes = CryptoJS.enc.Base64.parse(encryptedText);
    const iv = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(0, 4));
    const ciphertext = CryptoJS.lib.WordArray.create(encryptedBytes.words.slice(4));
    const key = CryptoJS.SHA256(passphrase);
    const decrypted = CryptoJS.AES.decrypt(
        { ciphertext },
        key,
        {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
}

const getScrollDir = () => {
    let showFlag = false;
    let positionCurrent = 0;
    let topDom = $('.gototop')

    $(window).scroll(function () {
        const positionDiff = positionCurrent - $(window).scrollTop();
        positionCurrent = $(window).scrollTop();

        if ((positionDiff > 0 && positionCurrent > 0) && positionCurrent + $(window).height() < $(document).height()) {
            if (!showFlag) {
                topDom.addClass('show')
                showFlag = true;
            }
        } else {
            if (showFlag) {
                topDom.removeClass('show')
                showFlag = false;
            }
        }
    })
}

const init = () => {
    setGAEvent()
    getScrollDir()
}

init()

// HTML内直書きのgtag対応 
window.gtag = gtag